{
  "name": "hub",
  "version": "9.0.4",
  "license": "MIT",
  "browser": {
    "crypto": false,
    "fs": false
  },
  "config": {
    "commitizen": {
      "path": "cz-conventional-changelog"
    }
  },
  "sideEffects": false,
  "elf": {
    "cli": {
      "repoTemplate": "class",
      "inlineStoreInClass": true,
      "repoLibrary": "state",
      "plugins": [
        "@ngneat/elf-cli-ng"
      ]
    }
  },
  "scripts": {
    "all:build": "nx run-many --target=build --parallel=1 --all --exclude=arma,gorazd,lana-tester",
    "lint": "nx run-many --target=lint --all --parallel --exclude=dashboard,lana-tester,merc",
    "test": "nx run-many --target=test --all --parallel --code-coverage --exclude=dashboard,merc",
    "test:affected": "nx affected --target=test --parallel --exclude=dashboard,fulltext,merc",
    "ng": "ng",
    "prepare": "husky install",
    "docs:start": "npm start --prefix=docs",
    "docs:build": "npm run build --prefix=docs",
    "docs:deploy": "npm run deploy --prefix=docs",
    "gulliver:i18n-extract": "npx transloco-keys-manager extract --config apps/gulliver --unflat --sort",
    "gulliver:i18n-find": "npx transloco-keys-manager find --config apps/gulliver --unflat --sort"
  },
  "private": true,
  "dependencies": {
    "@acrodata/code-editor": "^0.5.1",
    "@angular/animations": "19.2.8",
    "@angular/cdk": "19.2.11",
    "@angular/common": "19.2.8",
    "@angular/compiler": "19.2.8",
    "@angular/core": "19.2.8",
    "@angular/elements": "19.2.8",
    "@angular/forms": "19.2.8",
    "@angular/material": "19.2.11",
    "@angular/material-date-fns-adapter": "19.2.11",
    "@angular/platform-browser": "19.2.8",
    "@angular/platform-browser-dynamic": "19.2.8",
    "@angular/router": "19.2.8",
    "@codemirror/language-data": "^6.5.1",
    "@fancyapps/fancybox": "^3.5.7",
    "@fancyapps/ui": "^4.0.31",
    "@iiif/presentation-2": "^1.0.2",
    "@iiif/presentation-3": "^1.1.1",
    "@jsverse/transloco": "^7.0.0",
    "@jsverse/transloco-messageformat": "^7.0.1",
    "@material/material-color-utilities": "^0.3.0",
    "@ng-matero/extensions": "^19.0.0",
    "@ngneat/elf": "^2.3.0",
    "@ngneat/elf-cli-ng": "^1.0.0",
    "@ngneat/elf-devtools": "^1.2.1",
    "@ngneat/elf-entities": "^4.4.3",
    "@ngneat/elf-ng-router-store": "^1.0.8",
    "@ngneat/elf-persist-state": "^1.1.6",
    "@ngneat/elf-requests": "^1.8.0",
    "@ngneat/elf-state-history": "^1.3.0",
    "@ngneat/forms-manager": "^2.5.0",
    "@ngneat/until-destroy": "^10.0.0",
    "@panzoom/panzoom": "^4.4.4",
    "@sentry/angular": "^9.0.0",
    "@sentry/browser": "^9.0.0",
    "@sentry/cli": "^2.5.2",
    "@swimlane/ngx-graph": "^9.0.0",
    "d3-scale": "^4.0.2",
    "d3-shape": "^3.2.0",
    "d3-transition": "^3.0.1",
    "date-fns": "^2.28.0",
    "date-fns-tz": "^1.3.5",
    "file-saver": "^2.0.5",
    "immer": "^9.0.15",
    "jexl": "^2.3.0",
    "jquery": "^3.6.0",
    "keycloak-angular": "^16.0.0",
    "keycloak-js": "^25.0.2",
    "lint-staged": "^16.1.0",
    "lucene": "^2.1.1",
    "marked": "^4.3.0",
    "masonry-layout": "^4.2.2",
    "ng-lazyload-image": "^9.0.0",
    "ngx-annotate-text": "^18.0.0",
    "ngx-cookie-service": "^19.0.0",
    "ngx-google-analytics": "^14.0.0",
    "ngx-lightbox": "^3.0.0",
    "ngx-markdown": "^19.0.0",
    "ngx-quill": "^27.0.0",
    "ngx-schema-form": "2.12.0",
    "ol": "^7.1.0",
    "ol-layerswitcher": "^4.1.0",
    "process": "^0.11.10",
    "quill": "^2.0.0",
    "rxjs": "^7.4.0",
    "simple-keyboard": "^3.5.26",
    "stream-browserify": "^3.0.0",
    "timers-browserify": "^2.0.12",
    "tslib": "^2.3.0",
    "url-search-params-polyfill": "^8.1.1",
    "uuid": "^9.0.0",
    "vanilla-cookieconsent": "^2.8.2",
    "xml-js": "^1.6.11",
    "z-schema": "^4.2.3",
    "zod": "^3.24.4",
    "zone.js": "0.15.0"
  },
  "devDependencies": {
    "@angular-devkit/build-angular": "19.2.9",
    "@angular-devkit/core": "19.2.9",
    "@angular-devkit/schematics": "19.2.9",
    "@angular-eslint/eslint-plugin": "19.2.0",
    "@angular-eslint/eslint-plugin-template": "19.2.0",
    "@angular-eslint/schematics": "19.2.0",
    "@angular-eslint/template-parser": "19.2.0",
    "@angular/cli": "~19.2.0",
    "@angular/compiler-cli": "19.2.8",
    "@babel/preset-env": "^7.14.1",
    "@commitlint/cli": "^17.0.3",
    "@commitlint/config-conventional": "^17.0.3",
    "@eslint/eslintrc": "^2.1.1",
    "@jsverse/transloco-keys-manager": "^6.0.0",
    "@ngneat/spectator": "^19.0.0",
    "@nx/angular": "20.8.0",
    "@nx/cypress": "20.8.0",
    "@nx/devkit": "20.8.0",
    "@nx/eslint": "20.8.0",
    "@nx/eslint-plugin": "20.8.0",
    "@nx/jest": "20.8.0",
    "@nx/js": "20.8.0",
    "@nx/playwright": "20.8.0",
    "@nx/workspace": "20.8.0",
    "@playwright/test": "^1.36.0",
    "@schematics/angular": "19.2.9",
    "@semantic-release/changelog": "^6.0.3",
    "@semantic-release/git": "^10.0.1",
    "@semantic-release/gitlab": "^9.5.1",
    "@semantic-release/npm": "^11.0.0",
    "@stylistic/eslint-plugin": "^4.4.0",
    "@swc-node/register": "~1.9.1",
    "@swc/core": "~1.5.7",
    "@swc/helpers": "~0.5.11",
    "@tailwindcss/aspect-ratio": "^0.4.0",
    "@types/fancybox": "^3.5.2",
    "@types/jest": "^29.5.12",
    "@types/jquery": "^3.5.14",
    "@types/node": "^22.0.0",
    "@types/webpack": "^5.28.0",
    "@typescript-eslint/utils": "^8.19.0",
    "angular-eslint": "^19.2.0",
    "conventional-changelog-conventionalcommits": "^8.0.0",
    "eslint": "^9.8.0",
    "eslint-config-prettier": "^10.1.5",
    "eslint-plugin-jest": "^28.0.0",
    "eslint-plugin-playwright": "^0.15.3",
    "eslint-plugin-prettier": "^5.4.0",
    "eslint-plugin-tailwindcss": "^3.18.0",
    "husky": "^8.0.1",
    "jest": "^29.7.0",
    "jest-environment-jsdom": "^29.7.0",
    "jest-junit": "^16.0.0",
    "jest-preset-angular": "14.4.2",
    "jsonc-eslint-parser": "^2.1.0",
    "ng-mocks": "^14.0.0",
    "nx": "20.8.0",
    "prettier": "2.8.4",
    "sass-loader": "^12.6.0",
    "tailwind-bootstrap-grid": "^5.0.1",
    "tailwindcss": "^3.0.24",
    "tailwindcss-debug-screens": "^2.2.1",
    "ts-jest": "^29.1.0",
    "ts-node": "10.9.1",
    "typescript": "5.7.3",
    "typescript-eslint": "^8.19.0",
    "util": "^0.12.4",
    "webpack-dev-server": "^4.15.1"
  },
  "optionalDependencies": {
    "fsevents": "*"
  },
  "overrides": {
    "ngx-schema-form": {
      "rxjs": "^7.4.0"
    },
    "d3-selection": "3.0.0"
  },
  "packageManager": "yarn@1.22.19+sha1.4ba7fc5c6e704fce2066ecbfb0b0d8976fe62447"
}
